module.exports = __webpack_public_path__ + "f3ca161d07c879c12ab54d03bb7f1558.svg";